import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Loader } from '@components/shared/Loader/Loader';
import { AppMode } from '@helpers/appMode';
import { isRecruiterPortal } from '@helpers/utils';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Box from '@mui/material/Box';

const AppModeDialog = () => {
  const { t, ready } = useTranslation('recruiter');

  const handleContinue = () => {
    const localStorageKeys = [
      AppMode.APP_MODE,
      'clientOrganizationId',
      'selectedConfigurationId',
      'applicationId',
      'userId',
      'redirectionUrl',
      'redux_admin_auth_state',
      'redux_app_auth_state',
    ];
    localStorageKeys.forEach((key: string) => localStorage.removeItem(key));
    window.location.reload();
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (isRecruiterPortal()) return;
      localStorage.removeItem('clientOrganizationId');
      localStorage.removeItem('selectedConfigurationId');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  if (!ready) return <Loader />;

  return (
    <Dialog open={true} maxWidth="md" fullWidth={true}>
      <Box>
        <DialogTitle>
          <p className="tag-ds  h4">{t('recruiter:GENERAL.APP_MODE.title')}</p>
        </DialogTitle>
        <DialogContent>
          <Box className="tag-ds  medium" mb={3}>
            <strong>
              {isRecruiterPortal()
                ? t('recruiter:GENERAL.APP_MODE.messageRecruiter')
                : t('recruiter:GENERAL.APP_MODE.messageCandidate')}
            </strong>
          </Box>

          <Box>
            <p>
              {isRecruiterPortal()
                ? t('recruiter:GENERAL.APP_MODE.recommendationCandidate')
                : t('recruiter:GENERAL.APP_MODE.recommendationRecruiter')}
            </p>
            <p>
              <Trans
                i18nKey="recruiter:GENERAL.APP_MODE.resolution"
                components={{
                  kbArticleLink: (
                    <a
                      href="https://adecco.service-now.com/kb?id=kb_article_view&sysparm_article=KB0058629"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                }}
              />
            </p>
          </Box>
        </DialogContent>
        <DialogActions>
          <div className="tag-ds ">
            <button onClick={handleContinue}>{t('recruiter:GENERAL.APP_MODE.confirm')}</button>
          </div>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default AppModeDialog;
